import { Component, HostListener, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { PageMenuItem, PageState } from 'app/store/models/page.model';
import { getMenuItems } from 'app/store/selectors/page.selector';
import { getIsAuthenticated } from 'app/store/selectors/user.selector';
import { logout } from 'app/store/actions/user.action';
import { UserState } from 'app/store/models/user.model';
import { IReducers } from '../../store/reducers';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isSticky = false;

  isUserAuthenticated$: Observable<boolean>;

  page$: Observable<PageState>;
  menuItems: Observable<PageMenuItem[]>;

  constructor(
    private store: Store<IReducers>,
    private router: Router,
  ) {
    this.menuItems = this.store.pipe(select(getMenuItems));
    this.isUserAuthenticated$ = this.store.select(getIsAuthenticated);
  }

  logout = () => {
    this.store.select('user').subscribe((result: UserState) => {
      if (!result.loggedIn) {
        if (environment.production) {
          window.location.href = 'https://retreva.com';
          return;
        }
        this.router.navigate(['/login']);
      }
    });
    this.store.dispatch(logout());
  };

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    this.isSticky = window.pageYOffset >= 250;
  }

  ngOnInit() {
  }
}
